import { Button, Text } from '@react-spectrum/s2';
import ChevronRight from '@react-spectrum/s2/icons/ChevronRight';
import { useCallback, useState } from 'react';

import { TypewriterOnce } from '../components/TypewriterOnce';

type WelcomeScreenProps = {
	onContinue: () => void;
};

export const WelcomeScreen = ({ onContinue }: WelcomeScreenProps) => {
	const [typingDone, setTypingDone] = useState(false);
	const handleTypingDone = useCallback(() => setTypingDone(true), []);

	return (
		<div className="flex h-full w-full items-center justify-center">
			<div className="w-full max-w-[760px] px-8">
				<h1
					className="mb-8"
					style={{
						fontSize: 'clamp(26px, 4vw, 40px)',
						fontWeight: 700,
						letterSpacing: '-0.03em',
						lineHeight: 1.05,
						color: 'var(--text-primary)',
					}}
				>
					<TypewriterOnce
						text="Hey. I'm Bridgeway."
						onDone={handleTypingDone}
					/>
				</h1>

				<div
					style={{
						opacity: typingDone ? 1 : 0,
						transition: 'opacity 400ms ease',
						pointerEvents: typingDone ? 'auto' : 'none',
					}}
				>
					<Button
						variant="primary"
						staticColor="black"
						fillStyle="fill"
						size="L"
						onPress={onContinue}
					>
						<Text>Nice to meet you</Text>
						<ChevronRight />
					</Button>
				</div>
			</div>
		</div>
	);
};
